import { Component, Input } from '@angular/core';
import {
  AbstractWorkspaceHostComponent,
  AbstractWorkspaceInputs,
} from '../../shared/abstract-workspace-host.component';
import { SamplingWorkspaceComponent } from './sampling-workspace.component';

const samplingWorkspaceInputKeys = [
  'projectId',
  'sampleId',
  'initialPosition',
] as const;

export type SamplingWorkspaceInputs = Pick<
  SamplingWorkspaceComponent,
  (typeof samplingWorkspaceInputKeys)[number]
> &
  AbstractWorkspaceInputs;

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection -- no loading state with on push
@Component({
  selector: 'h3-sampling-workspace-host',
  templateUrl: '../../shared/abstract-workspace-host.component.html',
  standalone: false,
})
export class SamplingWorkspaceHostComponent
  extends AbstractWorkspaceHostComponent<SamplingWorkspaceComponent>
  implements SamplingWorkspaceInputs
{
  @Input({ required: true, transform: Number }) projectId!: number;
  @Input({ required: true, transform: Number }) sampleId!: number;
  @Input({ required: true, transform: Number }) initialPosition!: number;

  constructor() {
    super(SamplingWorkspaceComponent, samplingWorkspaceInputKeys);
  }

  protected override getProjectId() {
    return this.projectId;
  }
}
